"use strict";

var _objectSpread = require("/codebuild/output/src2730718938/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _colors = require("../config/colors.config");
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var groupBase = function groupBase(theme) {
  return {
    backgroundColor: theme.palette.background.paper,
    border: "1px solid ".concat(_colors.Black[85]),
    borderRadius: 21,
    boxShadow: "0px 2px 2px ".concat(_colors.Black[19]),
    height: 42,
    margin: 2,
    minWidth: 114,
    position: 'relative',
    width: 114
  };
};
var orangBorder = function orangBorder(theme) {
  return {
    backgroundColor: 'transparent',
    border: "2px solid ".concat(theme.palette.primary.main),
    borderRadius: 22,
    borderWidth: theme.palette.type === 'light' ? '2px' : '3px',
    content: '""',
    display: 'block',
    height: 44,
    pointerEvents: 'none',
    position: 'absolute',
    top: '-2px',
    transition: 'right 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    width: 67,
    zIndex: 0
  };
};
var buttonBase = function buttonBase(theme) {
  return {
    '& .MuiRadio-root': {
      top: 0
    },
    '& .MuiRadio-root + .MuiFormControlLabel-label': {
      border: 'none',
      boxShadow: 'none',
      height: 42,
      lineHeight: '40px',
      margin: 0,
      padding: 0,
      position: 'absolute',
      textAlign: 'center',
      width: 64,
      zIndex: 1
    },
    '&:hover': {
      backgroundColor: _helpers.agentDeveloperUtils.getPrimaryColor(30),
      boxShadow: "0px 2px 2px ".concat(_colors.Black[19])
    },
    '&:hover span.MuiTypography-root': {
      color: theme.palette.type === 'light' ? _helpers.agentDeveloperUtils.getPrimaryColor(450) : _colors.Black[900]
    },
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: 20,
    height: 40,
    margin: 0,
    padding: 0,
    position: 'absolute',
    width: 63,
    zIndex: 1
  };
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    btn: _objectSpread(_objectSpread({}, buttonBase(theme)), {}, {
      '&:first-child': {
        left: -1,
        right: 'unset'
      },
      '&:nth-child(2)': {
        left: 'unset',
        right: -1
      }
    }),
    children: {
      left: '123px',
      position: 'absolute'
    },
    legend: {
      marginRight: 20
    },
    no: _objectSpread(_objectSpread({}, groupBase(theme)), {}, {
      '&:after': _objectSpread(_objectSpread({}, orangBorder(theme)), {}, {
        right: '-3px',
        width: 68
      })
    }),
    none: _objectSpread(_objectSpread({}, groupBase(theme)), {}, {
      '&:after': _objectSpread(_objectSpread({}, orangBorder(theme)), {}, {
        display: 'none'
      })
    }),
    secondBtnWithChildren: {
      '&:nth-child(2)': {
        left: 'unset',
        right: -21
      }
    },
    wrapper: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap'
    },
    yes: _objectSpread(_objectSpread({}, groupBase(theme)), {}, {
      '&:after': _objectSpread(_objectSpread({}, orangBorder(theme)), {}, {
        right: '48px',
        width: 67
      })
    })
  };
});
var YesNoRadioGroup = function YesNoRadioGroup(props) {
  var classes = useStyles();
  var groupClass = classes.no;
  if (props.value === 'yes') {
    groupClass = classes.yes;
  }
  if (props.value === '') {
    groupClass = classes.none;
  }
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper
  }, props.label ? /*#__PURE__*/_react.default.createElement(_core.FormLabel, {
    style: computedStyle(props.labelWidth),
    className: classes.legend,
    component: 'legend',
    id: props.name + '-label'
  }, props.label) : false, /*#__PURE__*/_react.default.createElement(_core.RadioGroup, {
    row: true,
    value: props.value,
    onChange: props.onChange,
    classes: {
      root: groupClass
    },
    name: props.name,
    "data-testid": "".concat(props.name, "-radio-group"),
    "aria-labelledby": props.label ? props.name + '-label' : null,
    "aria-label": props.label ? null : props.name
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    classes: {
      root: classes.btn
    },
    value: 'yes',
    control: /*#__PURE__*/_react.default.createElement(_core.Radio, {
      inputProps: {
        'aria-setsize': '2'
      }
    }),
    label: 'כן',
    disabled: props.disabled
  }), /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    classes: {
      root: "".concat(classes.btn, " ").concat(props.children ? classes.secondBtnWithChildren : '')
    },
    value: 'no',
    control: /*#__PURE__*/_react.default.createElement(_core.Radio, {
      inputProps: {
        'aria-setsize': '2'
      }
    }),
    label: 'לא',
    disabled: props.disabled
  }), props.children && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.children
  }, props.children))));
};
YesNoRadioGroup.propTypes = {
  children: _propTypes.default.any,
  disabled: _propTypes.default.bool,
  label: _propTypes.default.string,
  labelWidth: _propTypes.default.number,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  value: _propTypes.default.string
};
var computedStyle = function computedStyle(width) {
  if (!width) {
    return {};
  }
  return {
    width: "".concat(width, "px")
  };
};
var _default = exports.default = YesNoRadioGroup;